import { useEffect, useState } from "react";
import TopNavInstantSearch from "./TopNavInstantSearch";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import profileicon from "../../../../../assets/img/icon-profile.svg"
import { GeneralDropDowns } from "../../../../../actions/GeneralPatientActions";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

const GlobalInstantSearch = () => {
    const [focused, setIsFocused] = useState(false)
    const [selectedSearch, setSelectedSearch] = useState('Patient');
    let GenDD = useSelector(state => state.GeneralDropDownsReducer);
    const dispatch = useDispatch();

    // To Change Type of Global Search
    const handleSelectedSearch = (event) => {
        setSelectedSearch(event.target.value);
    };
    useEffect(() => {
        if (GenDD?.isGLobalSearchFocused && GenDD?.isGLobalSearchFocused !== false) {
            if (GenDD?.isGLobalSearchFocused === 'Patient') {
                setSelectedSearch(GenDD?.isGLobalSearchFocused);
            } else if (GenDD?.isGLobalSearchFocused === 'Billing') {
                setSelectedSearch(GenDD?.isGLobalSearchFocused);
            } else if (GenDD?.isGLobalSearchFocused === 'Profile') {
                setSelectedSearch(GenDD?.isGLobalSearchFocused);
            }
            setIsFocused(true)
            dispatch(GeneralDropDowns({ ...GenDD, isGLobalSearchFocused: false }))
        }
    }, [GenDD?.isGLobalSearchFocused])

    return (<>

        <div className={`input header-search mt-2 no-round-right search_engine ${focused ? 'ar-global-instant-focus' : ''}`}>
            <div className="input-group with-icon-start">
                <TopNavInstantSearch selectedSearch={selectedSearch} setIsFocused={setIsFocused} focused={focused} />
                <span className="input-group-text p-0">
                    <Select
                        value={selectedSearch}
                        onChange={handleSelectedSearch}
                        renderValue={(selected) => {
                            return (
                                <div className="dropDown-Box__content">
                                    <p>{selected}</p>
                                </div>
                            );
                        }}
                        displayEmpty
                        className='app-mui-select-no-ui'>
                        <MenuItem value={'Patient'} className='dropDown-Box'>
                            <div className="dropDown-Box__icon">
                                <i className="icon-users" />
                            </div>
                            <div className="dropDown-Box__content">
                                <p>Patient</p>
                                <span>Find by Name, Subscriber ID, Medicaid #, Address, Phone, Email</span>
                            </div>
                        </MenuItem>
                        <MenuItem value={'Billing'} className='dropDown-Box'>
                            <div className="dropDown-Box__icon">
                                <i className="icon-billing" />
                            </div>
                            <div className="dropDown-Box__content">
                                <p>Billing</p>
                                <span>Find by Claim #, Subscriber ID, Check #</span>
                            </div>
                        </MenuItem>
                        <MenuItem value={'Profile'} className='dropDown-Box'>
                            <div className="dropDown-Box__icon">
                                <img src={profileicon} alt="icon" />
                            </div>
                            <div className="dropDown-Box__content">
                                <p>Profile</p>
                                <span>Find by NPI, Name, ICD, CPT, POS, Insurance</span>
                            </div>
                        </MenuItem>
                    </Select>
                </span>
            </div>
        </div>
    </>);
}

export default GlobalInstantSearch;